// /home/lucabrugaletta/Desktop/Works council/frontend/src/pages/Register.js
import React, { useState } from 'react';
import { 
  Box, 
  Typography, 
  TextField, 
  Button, 
  Paper, 
  CircularProgress, 
  Alert,
  Link as MuiLink,
  FormControl,
  InputLabel,
  Select,
  MenuItem
} from '@mui/material';
import { Link, useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import { useAuth } from '../contexts/AuthContext';
import '../styles/shared.css';

const Register = () => {
  const navigate = useNavigate();
  const { register, login } = useAuth();
  const [formData, setFormData] = useState({
    email: '',
    name: '',
    password: '',
    business_unit: '',
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    
    try {
      // Register user
      await register(formData);
      
      // Auto login
      await login(formData.email, formData.password);
      navigate('/dashboard');
    } catch (err) {
      setError(err.response?.data?.detail || 'Registration failed');
      setLoading(false);
    }
  };

  return (
    <div className="centered-page">
      <Paper 
        component={motion.div}
        initial={{ opacity: 0, y: -20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
        elevation={4}
        className="glass-paper form-container form-wide"
      >
        <Typography variant="h4" component="h1" align="center" className="text-primary" sx={{ mb: 4, fontWeight: 600 }}>
          Register
        </Typography>
        
        {error && (
          <Alert severity="error" sx={{ mb: 3 }}>
            {error}
          </Alert>
        )}
        
        <Box component="form" onSubmit={handleSubmit}>
          <TextField
            fullWidth
            label="Email"
            type="email"
            name="email"
            value={formData.email}
            onChange={handleChange}
            required
            className="mui-input form-field"
          />
          
          <TextField
            fullWidth
            label="Full Name"
            type="text"
            name="name"
            value={formData.name}
            onChange={handleChange}
            required
            className="mui-input form-field"
          />
          
          <FormControl 
            fullWidth 
            margin="normal" 
            required
            sx={{ mb: 2 }}
          >
            <InputLabel>Business Unit</InputLabel>
            <Select
              name="business_unit"
              value={formData.business_unit}
              label="Business Unit"
              onChange={handleChange}
            >
              <MenuItem value="Defence and Security (D&S)">Defence and Security (D&S)</MenuItem>
              <MenuItem value="Environment and Sustainability (E&S)">Environment and Sustainability (E&S)</MenuItem>
              <MenuItem value="General and Administrative (G&A)">General and Administrative (G&A)</MenuItem>
              <MenuItem value="High-tech Consulting (HTC)">High-tech Consulting (HTC)</MenuItem>
              <MenuItem value="Space and Science (S&S)">Space and Science (S&S)</MenuItem>
            </Select>
          </FormControl>
{/*           
          <TextField
            fullWidth
            label="Joining Date"
            type="date"
            name="joining_date"
            value={formData.joining_date}
            onChange={handleChange}
            required
            margin="normal"
            InputLabelProps={{
              shrink: true,
            }}
            helperText="When did you start at the company?"
            sx={{
              mb: 2,
              '& .MuiOutlinedInput-root': {
                '&.Mui-focused fieldset': {
                  borderColor: '#702963',
                  boxShadow: '0 0 0 3px rgba(112, 41, 99, 0.2)'
                }
              }
            }}
          /> */}
          
          <TextField
            fullWidth
            label="Password"
            type="password"
            name="password"
            value={formData.password}
            onChange={handleChange}
            required
            margin="normal"
            sx={{
              mb: 3,
              '& .MuiOutlinedInput-root': {
                '&.Mui-focused fieldset': {
                  borderColor: '#702963',
                  boxShadow: '0 0 0 3px rgba(112, 41, 99, 0.2)'
                }
              }
            }}
          />
          
          <Button
            fullWidth
            type="submit"
            variant="contained"
            disabled={loading}
            className="btn-primary"
            sx={{ py: 1.5 }}
          >
            {loading ? <CircularProgress size={24} sx={{ color: 'white' }} /> : "Register"}
          </Button>
          
          <Box sx={{ mt: 3, textAlign: 'center' }}>
            <Typography variant="body2">
              Already have an account? {' '}
              <MuiLink component={Link} to="/login" sx={{ color: '#99D6D6' }}>
                Login
              </MuiLink>
            </Typography>
          </Box>
        </Box>
      </Paper>
    </div>
  );
};

export default Register;